var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUpDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1249,
    height: 1016,
    viewBox: "0 0 1249 1016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1249,
    height: 1016,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3555.561,819.166s271.279,283.564,45.878,590.562c-199.991,272.39-433.16,253.77-604.235,143.231-72.861-47.078-345.042-8.5-583.057,222.645-253.4,246.077-931.185,125.2-813.59-384.078,65.475-283.558-226.965-291.648-73.319-572.956Z",
    transform: "translate(-1407.005 -882.571)",
    fill: "#0533b3",
    opacity: 0.05
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpDecor);
export default __webpack_public_path__ + "static/media/sign-up-decor.52b29dceb6d7be40b36d7770a07d43e6.svg";
export { ForwardRef as ReactComponent };